import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FormService {
  formSubmitted = false;
  formTableMaps = new Map();
}
